import React from "react";
import { useTranslation } from "react-i18next";
import { Accordion } from "./views/home/Accordion";
import { CashOutTable } from "./views/home/CashOutTable";
import { Ghosted } from "./Ghosted";
import CustomPieChart from "./graphs/CustomPieChart";
import MonthlyFinancialChart from "./graphs/MonthlyFinancialChart";
import { PyramidChart } from "./graphs/PyramidChart";
import { DebtScamChart } from "./graphs/DebtScamChart";
import { VideoThumbnails } from "./VideoThumbnails";
import billions from './preloaded/billios_videos.json'
import { WalletsMergedTable } from "./views/home/WalletsMergedTable";
import { GenericSeo } from "./views/shared/GenericSeo";

export const Home = () => {
  const { t } = useTranslation();

  return (
    <>
      <GenericSeo routeName={'home'} />
      <VideoThumbnails videos={billions} />
      <p className="mb-4" dangerouslySetInnerHTML={{ __html: t("home_info") }}></p>

      <CashOutTable />
      <WalletsMergedTable />
      <CustomPieChart />
      <MonthlyFinancialChart />
      <Ghosted />
      <DebtScamChart />
      <br />
      <PyramidChart />
      <Accordion />
    </>
  );
}
